export const TIMEOUT_OPTIONS = {
  1: '1 day',
  2: '2 days',
  3: '3 days',
  4: '4 days',
  5: '5 days',
  6: '6 days',
  7: '1 week',
  14: '2 weeks',
  21: '3 weeks',
  31: '1 month',
  62: '2 months',
  93: '3 months',
};

export const SELF_EXCLUDE_OPTIONS = {
  6: '6months',
  9: '9months',
  12: '12months',
  24: '24months',
  48: '48months',
  60: '60months',
};
